var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4959 5.74995C17.482 5.6099 17.4329 5.47566 17.353 5.35979C17.2731 5.24392 17.1652 5.15022 17.0392 5.08745L10.3725 1.75411C10.2568 1.69618 10.1291 1.66602 9.99962 1.66602C9.87016 1.66602 9.74248 1.69618 9.6267 1.75411L2.96003 5.08745C2.83443 5.15057 2.72679 5.24439 2.64711 5.36021C2.56743 5.47602 2.51827 5.61007 2.5042 5.74995C2.49503 5.83911 1.70337 14.7224 9.6617 18.2616C9.76804 18.3096 9.88337 18.3344 10 18.3344C10.1167 18.3344 10.232 18.3096 10.3384 18.2616C18.2967 14.7224 17.505 5.83995 17.4959 5.74995ZM10 16.5808C4.3592 13.8541 4.09253 8.03495 4.13837 6.36245L10 3.43161L15.8575 6.36078C15.8884 8.01828 15.5842 13.8758 10 16.5808Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1668 10.4884L7.25597 8.57756L6.07764 9.75589L9.1668 12.8451L13.9226 8.08922L12.7443 6.91089L9.1668 10.4884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInsurance);
export default __webpack_public_path__ + "static/media/ic-insurance.f26cdf46f779812aabf8e1ca8f98203e.svg";
export { ForwardRef as ReactComponent };